import { defineMessages } from 'react-intl';

export const floatingAskHeidiInputMessages = defineMessages({
  placeholderAskHeidiAnything: {
    defaultMessage: 'Ask Heidi anything...',
    id: 'W3AZ6pvFFY',
    description:
      'Placeholder in the floating Ask Heidi input when Heidi branding is shown and source control v2 is off',
  },
  placeholderWhiteLabel: {
    defaultMessage: 'Ask Evidence',
    id: 'Ey2waFVft0',
    description:
      'Placeholder in the floating Ask Heidi input for white-label Evidence branding',
  },
  placeholderV2FloatingBar: {
    defaultMessage: 'Ask a question or edit your note...',
    id: 'XtjylqNP7I',
    description:
      'Placeholder in the floating Ask Heidi input when source control v2 is enabled',
  },
  placeholderAskAnything: {
    defaultMessage: 'Ask anything...',
    id: 'QWZikNYXYh',
    description:
      'Placeholder in the floating Ask Heidi input before a note is generated (pre and during transcription)',
  },
  placeholderAskEditCreate: {
    defaultMessage: 'Ask, edit or create...',
    id: 'HDpeuzlAYK',
    description:
      'Placeholder in the floating Ask Heidi input after a note has been generated (post)',
  },
  placeholderTypeToPrep: {
    defaultMessage: 'Type / to prep',
    id: 'c7VA9ee2oI',
    description:
      'Rotating placeholder hint in the floating Ask Heidi input nudging the user to open the slash menu to prep',
  },
  placeholderTypeForShortcuts: {
    defaultMessage: 'Type / for shortcuts',
    id: 'jPhZESslxc',
    description:
      'Rotating placeholder hint in the floating Ask Heidi input nudging the user to open the slash menu for shortcuts',
  },
  sendMessage: {
    defaultMessage: 'Send message',
    id: 'ExfQ5G9SWO',
    description: 'Accessible name for the button that submits the Ask Heidi prompt',
  },
});
